<template>
  <div
    class="d-flex flex-column card mb-10"
    :style="cardStyle"
    :key="item.id_colaboracao"
  >
    <div class="d-flex align-center" style="height: 100%">
      <div
        v-if="item.url_avatar_colaborador"
        class="d-flex avatar-wrapper align-self-center ma-2"
      >
        <v-img
          class="rounded-lg"
          width="180"
          height="180"
          :src="item.url_avatar_colaborador"
        />
      </div>
      <div class="d-flex flex-column">
        <header class="d-flex">
          <div class="d-flex align-center">
            <span
              class="font-weight-black ml-4"
              style="font-family: Fixture !important; font-size: 1.8rem"
              :style="{ color: headerInfoColor }"
            >
              {{ item.dsc_nome_colaborador }}
            </span>
            <span
              class="font-weight-black ml-2"
              style="font-family: Fixture !important; opacity: 0.85; font-size: 1.4rem"
              :style="{ color: headerInfoColor }"
            >
              {{ item.dsc_colaborador_user }}
            </span>
          </div>
          <div
            class="d-inline-block flex-grow-1 align-self-center mx-4"
            :style="{ 'background-color': headerInfoColor }"
            style="min-height: 2px; max-height: 2px"
          ></div>
          <div v-if="item.dsc_fonte_colaboracao === 'twitter'">
            <TwitterSvg
              class="mr-2 mt-2"
              style="width: 24px; height: 24px"
              :style="{ fill: headerInfoColor }"
            />
          </div>
          <div v-else-if="item.dsc_fonte_colaboracao === 'threads'">
            <ThreadsLogo
              class="mr-2 mt-2"
              style="width: 24px; height: 24px"
              :style="{ fill: headerInfoColor }"
            />
          </div>
          <div v-else-if="item.dsc_fonte_colaboracao === 'bluesky'">
            <BlueskySvg
              class="mr-2 mt-2"
              style="width: 28px; height: 28px"
              :style="{ fill: headerInfoColor }"
            />
          </div>
        </header>
        <section class="d-flex align-center flex-grow-1 mx-1" style="min-height: 130px">
          <div
            v-if="!item.dsc_tipo_midia_colaboracao"
            v-html="colabText"
            class="px-4 font-weight-medium"
            style="font-family: Fixture"
            :style="{
              lineHeight: lineHeight,
              fontSize: bodyTextSize,
              color: bodyTextColor,
            }"
          ></div>
          <div
            v-else-if="item.dsc_tipo_midia_colaboracao === 'audio'"
            style="width: 100%"
            class="d-flex align-center justify-center px-8"
          >
            <audio
              controls
              controlslist="nodownload"
              autoplay
              style="width: 100%"
              :key="item.url_midia_colaboracao"
            >
              <source :src="item.url_midia_colaboracao" />
            </audio>
          </div>
        </section>
        <footer
          class="d-flex flex-grow-1 align-center"
          :class="item.dsc_texto_colaboracao.trim().length > 40 ? 'mb-1' : ''"
        >
          <div
            class="d-inline-block flex-grow-1 mx-4"
            :style="{ 'background-color': headerInfoColor }"
            style="min-height: 2px; max-height: 2px"
          />
          <div class="mr-7 ma-0 pa-0">
            <span
              :style="{ color: headerInfoColor }"
              style="
                font-size: 1.6rem;
                text-transform: uppercase;
                font-family: Fixture;
                letter-spacing: 0.001rem;
              "
            >
              #<b>Papo</b>De<b>Segunda</b>No<b>Gnt</b>
            </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { formatTarjaText } from "@/utils/stringUtils";
import TwitterSvg from "@/assets/twitter.svg";
import BlueskySvg from "@/assets/bluesky.svg";
import ThreadsLogo from "@/assets/threads.svg";
export default {
  props: {
    item: Object,
    posicaoCard: String,
    flg_exibir_uf: Boolean,
    configCores: Object,
  },
  components: {
    TwitterSvg,
    BlueskySvg,
    ThreadsLogo,
  },
  data() {
    return {
      dsc_telefone_producao: null,
    };
  },
  async created() {
    await this.getNumTelefoneProducao();
  },
  computed: {
    backgroundColor() {
      return this.configCores.dsc_hex_cor_background;
    },
    bodyTextColor() {
      return this.configCores.dsc_hex_cor_texto;
    },
    headerInfoColor() {
      return this.configCores.dsc_hex_cor_header;
    },
    bodyTextSize() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "2.4rem"
          : numChars > 40 && numChars <= 80
          ? "2.3rem"
          : numChars > 80 && numChars <= 120
          ? "2.2rem"
          : numChars > 120 && numChars <= 160
          ? "2.1rem"
          : numChars > 160 && numChars <= 200
          ? "2rem"
          : numChars > 200 && numChars <= 240
          ? "1.9rem"
          : numChars > 240 && numChars <= 280
          ? "1.8rem"
          : "1.5rem";
      return size;
    },
    lineHeight() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "2.4rem"
          : numChars > 40 && numChars <= 80
          ? "2.3rem"
          : numChars > 80 && numChars <= 120
          ? "2.2rem"
          : numChars > 120 && numChars <= 160
          ? "2.1rem"
          : numChars > 160 && numChars <= 200
          ? "2rem"
          : numChars > 200 && numChars <= 240
          ? "1.9rem"
          : numChars > 240 && numChars <= 280
          ? "1.8rem"
          : "1.5rem";

      return lineHeight;
    },
    spanStyle() {
      return `color: ${this.configCores.dsc_hex_cor_header} !important;`;
    },
    colabText() {
      return formatTarjaText(this.item.dsc_texto_colaboracao, this.spanStyle);
    },
    cardStyle() {
      const position =
        this.posicaoCard === "esquerda" && !this.item.url_midia_colaboracao
          ? "margin-left: 100px; justify-self: flex-start"
          : this.posicaoCard === "centro"
          ? "justify-self: center"
          : this.posicaoCard === "direita" && !this.item.url_midia_colaboracao
          ? "margin-right: 40px; justify-self: flex-end"
          : this.posicaoCard === "direita" && this.item.url_midia_colaboracao
          ? "margin-right: 60px; justify-self: flex-start"
          : this.posicaoCard === "esquerda" && this.item.url_midia_colaboracao
          ? "margin-left: 120px; justify-self: flex-start"
          : "";
      const backgroundStyle = `background-color: ${this.backgroundColor}`;
      return position
        .split(";")
        .concat(backgroundStyle.split(";"))
        .filter((item) => item)
        .join(";");
    },
  },
  methods: {
    async getNumTelefoneProducao() {
      const cod_producao = localStorage.getItem("@socialcam/selected_option_production");
      await apiClient
        .get(`/listarDadosProducao/${cod_producao}`)
        .then((response) => {
          this.dsc_telefone_producao = response.data.producao.dsc_num_telefone;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  watch: {
    item: async function () {
      await this.getNumTelefoneProducao();
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Fixture";
  src: url("@/assets/fonts/Fixture-Regular.ttf") format("truetype");
}
.card {
  width: 840px;
  height: 240px;
  // border: 1px solid #61677A;
  border-radius: 1px;
}

.avatar-wrapper {
  width: 180px;
  height: 180px;
}
</style>
